// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".fafe60861f334051bc00b226f22bf4fd30cee810.chunk.js";
};